import { render, staticRenderFns } from "./ImpactSection.vue?vue&type=template&id=b5a88936&scoped=true&"
import script from "./ImpactSection.vue?vue&type=script&lang=js&"
export * from "./ImpactSection.vue?vue&type=script&lang=js&"
import style0 from "./ImpactSection.vue?vue&type=style&index=0&id=b5a88936&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a88936",
  null
  
)

export default component.exports